import { render, staticRenderFns } from "./qcStandard.vue?vue&type=template&id=4ca28a39&scoped=true"
import script from "./qcStandard.vue?vue&type=script&lang=js"
export * from "./qcStandard.vue?vue&type=script&lang=js"
import style0 from "./qcStandard.vue?vue&type=style&index=0&id=4ca28a39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca28a39",
  null
  
)

export default component.exports